import script from "./ButtonAddFiles.vue?vue&type=script&setup=true&lang=ts"
export * from "./ButtonAddFiles.vue?vue&type=script&setup=true&lang=ts"

import "./ButtonAddFiles.vue?vue&type=style&index=0&id=760d1c1b&lang=scss"

const __exports__ = script;

export default __exports__